module.exports = [
  require("./Banner"),
  require("./Header"),
  require("./Footer"),
  require("./ImageTextAside"),
  require("./ImageTextAsideReverse"),
  require("./TextCentered"),
  require("./FAQAccordion"),
];
